import { types } from 'mobx-state-tree';
import BankAccount from '../types/BankAccount';
import DebitAccount from "js/stores/types/DebitAccount";

export default types
  .model('ReceivingAccountForm', {
    requestInProgress: false,
    wasSuccessful: false,
    wasSubmitted: false,
    error: types.maybeNull(types.string),
    receivingAccount: types.optional(BankAccount, {}),
    receivingDebitAccount: types.optional(DebitAccount, {}),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
  }))
  .actions(self => {
    let hasClearedNumber = false;
    return {
      setIsRequesting(state = true) {
        self.requestInProgress = state;
        return self;
      },
      setError(message) {
        self.error = message;
        return self;
      },
      clearError() {
        self.error = null;
        return self;
      },
      setWasSuccessful(wasSuccessful = true) {
        self.wasSuccessful = wasSuccessful;
        return self;
      },
      setWasSubmitted(wasSubmitted = true) {
        self.wasSubmitted = wasSubmitted;
        return self;
      },
      clearNumber() {
        if (!hasClearedNumber) {
          self.receivingAccount.setNumber('');
          hasClearedNumber = true;
        }
      },
    };
  });
